module.exports = __webpack_public_path__ + "static/media/lora_co2_modbus.7fda965f.md";